<template>
	<button :class="['nkbtn btn btn-sm', 'position-relative', { 'btn-primary': settings.isPrimary, 'btn-warning': settings.isWarning, 'btn-danger': settings.isDanger, 'btn-outline-primary': !settings.isPrimary && !settings.isWarning && !settings.isDanger && settings.isOutline, 'btn-outline-danger': settings.isOutlineDanger, 'nextline-shortcut': settings.nextLineShortcut }, settings.class]" v-if="settings.visible" @click.stop="click" :disabled="disableStatus" :style="settings.style"
		:title="settings.tooltipEnabled ? tooltip : ''">
		<icon v-if="!settings.hideIcon && settings.icon && settings.icon != ''" :icon="settings.icon" class="icon" />
		<span v-if="!settings.hideTitle && settings.title != ''" class="button-title">{{ settings.title }}</span>
		<br v-if="settings.nextLineShortcut">
		<span v-if="!settings.hideShortcut && ((settings.shortcut && settings.shortcut.keyCode > 0) || settings.keyCode > 0)" class="shortcut">{{ shortcutDisplay }}</span>
		<span v-if="settings.badgeNumber !== ''" class="badge" :class="{ 'muted': settings.badgeNumber == 0 }">{{ settings.badgeNumber }}</span>
	</button>
</template>
<script>
	import _ from 'lodash'

	export default {
		props: {
			options: {
				type: Object,
			},
			disabled: {
				type: Boolean,
			},
		},
		emits: ['click', 'optionsChanged'],
		data() {
			return {
				settings: {
					id: this.idGenerator(5),
					isPrimary: false,
					isWarning: false,
					isDanger: false,
					isOutline: true,
					disabled: false,
					visible: true,
					nextLineShortcut: false,
					userHasAccess: null,
					icon: '',
					title: '',
					element: () => {
						return this.grandParent
					},
					hideShortcut: false,
					hideTitle: false,
					hideIcon: false,
					tooltipEnabled: false,
					tooltip: '',
					class: '',
					style: '',
					shortcut: {
						keyCode: 0,
						ctrlKey: false,
						shiftKey: false,
						altKey: false,
						display: '',
					},
					policyToken: null,
					badgeNumber: ''
				},
			}
		},
		created() {
			if (this.params?.options) this.settings = _.merge(this.settings, this.params.options)
		},
		watch: {
			options: {
				deep: true,
				handler(val, oldVal) {
					let callSubscribeKeys = !_.isEqual(this.settings.shortcut, val.shortcut)
					this.settings = _.merge(this.settings, val)
					if (callSubscribeKeys) {
						this.subscribeKeys()
					}
					// this.settings.visible = typeof (val.visible) === 'undefined' ? true : val.visible
					// this.settings.title = val.title
					// this.settings.shortcut = val.shortcut
					// this.settings.icon = val.icon
					// this.settings.handle = val.handle
					// this.settings.isPrimary = val.isPrimary
				}
			},
		},
		computed: {
			shortcutDisplay() {
				var arr = []
				var sc = this.settings.keyCode ? this.settings : this.settings.shortcut

				if (sc.keyCode > 0) {
					if (sc.ctrlKey === true) {
						arr.push('Ctrl')
					}
					if (sc.shiftKey === true) {
						arr.push('Shift')
					}
					if (sc.altKey === true) {
						arr.push('Alt')
					}

					var key = sc.keyCode
					var keyChar = String.fromKeyCode(key)
					keyChar = keyChar || ''

					arr.push(keyChar)
					return arr.join(' + ')
				} else {
					return ''
				}
			},
			tooltip() {

				if (this.settings.tooltip && this.settings.tooltip.length)
					return this.settings.tooltip

				let parts = []

				if (this.settings.title && this.settings.title.length > 0) {
					parts.push(this.settings.title)
				}

				if (this.shortcutDisplay.length > 0) {
					parts.push(`(${this.shortcutDisplay})`)
				}

				return parts.join(' ').trim()
			},
			disableStatus() {
				return (typeof this.settings.disabled === 'function' ? this.settings.disabled() : this.settings.disabled) || !this.settings.userHasAccess || this.disabled ? true : null
			}
		},
		mounted() {
			this.settings = _.merge(this.settings, this.options)
			this.checkUserPermission()
		},
		methods: {
			click(e) {
				if (!this.disableStatus) {
					this.hideShortcuts()
					this.$emit('click', this.settings, e)
					this.settings.agGridClickHandler && this.settings.agGridClickHandler()
				}
			},
			checkUserPermission() {
				let hasAccess = true
				if (this.settings.policyClaims != null) {
					hasAccess = this.$nikan.checkPermission(this.settings.policyClaims)
				}

				if (this.settings.userHasAccess !== hasAccess) {
					this.settings.userHasAccess = hasAccess
					this.$emit('optionsChanged', this.settings)
				}
			},
			subscribeKeys() {
				if (this.settings.shortcut.keyCode == 0) return
				this.$keyHandler.Subscribe({
					name: `${this.settings.title}-button-${this.settings.id}`,
					...this.settings.shortcut,
					el: this.settings.element(),
					context: this,
					handler: function (sender, e) {
						if (e.keyCode !== this.settings.shortcut.keyCode || this.disableStatus || !this.settings.visible || !this.settings.userHasAccess) {
							return
						}

						this.click(e)
						return true
					},
				})
			},
		},
	}
</script>
<style lang="less">
	@import "~/styles/site.config.less";

	.btn.disabled,
	.btn:disabled {
		z-index: 1;
	}

	.btn .icon {
		cursor: pointer !important;
	}

	.nextline-shortcut .shortcut {
		width: 100%;
		padding-right: 32px;
	}

	.nextline-shortcut .icon {
		position: relative;
		top: 8px;
	}

	.btn-primary.disabled,
	.btn-primary:disabled,
	.btn-outline-primary.disabled,
	.btn-outline-primary:disabled {
		background-color: transparent;
		border-color: #b2b2b2;
		cursor: not-allowed;
		z-index: 1;
	}

	.btn-outline-primary.disabled,
	.btn-outline-primary:disabled {
		color: @primary !important;
	}

	.nkbtn .badge {
		position: absolute !important;
		left: 3px;
		right: auto;
		top: 0px !important;
		background-color: red;
		color: white;
		border-radius: 50%;
		width: 20px;
		height: 20px;
		display: flex;
		justify-content: center;
		align-items: center;
		font-size: 12px;
	}

	.nkbtn .badge.muted {
		background-color: #b2b2b2;
	}

	@media screen and (max-width: 980px) {
		.nextline-shortcut .shortcut {
			text-align: center;
			padding: 0px !important;
		}
	}
</style>
